/* cs-au5-bridge -- AU5. Attribute an article-to-product move to the bridge.

   The beacon in theme.liquid reads cs_utm_* from sessionStorage on EVERY
   pageview and sends them to cs_track. So stamping sessionStorage on the click
   makes the NEXT pageview -- the product page -- carry the attribution, with
   no backend change and no new vendor.

   It writes cs_utm_content and NEVER cs_utm_source. utm_source is the field
   that separates this project's own automation from human traffic; the
   2026-08-21 contamination post-mortem rests on it. And it writes only when
   utm_content is currently empty, so a session that genuinely arrived carrying
   a utm_content keeps its first-touch value. */
(function () {
  if (location.hostname.indexOf('court-sportswear.com') === -1) return;
  try {
    var S = window.sessionStorage;
    document.addEventListener('click', function (e) {
      var a = e.target && e.target.closest
            ? e.target.closest('.cs-au2 a[href]') : null;
      if (!a) return;
      var href = a.getAttribute('href') || '';
      var m = href.match(/[?&]cs_bridge=([^&#]+)/);
      if (!m) return;
      var kind = a.classList.contains('cs-au2-card') ? 'card' : 'shelf';
      var val = ('bridge:' + kind + ':' + decodeURIComponent(m[1])).slice(0, 90);
      /* always readable by the verifier, even when we decline to overwrite */
      S.setItem('cs_bridge_last', val);
      if (!S.getItem('cs_utm_content')) S.setItem('cs_utm_content', val);
    }, true);
  } catch (e) { /* instrumentation must never break a purchase path */ }
})();
